module.exports = __webpack_public_path__ + "static/media/expand-arrow.4d07a63e.svg";